















































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import LocationDto from "@/models/Locations/LocationDto";
import UpdateLocationHealthAndSafetyRequest from "@/models/Locations/UpdateLocationHealthAndSafetyRequest";
import GiganautVueDialog from "@/components/Shared/GiganautVueDialog";
import { LocationDetailsModule } from "@/store/modules/locationDetails";
import DateTimeUtils from '@/lib/dateTimeUtils';

@Component({
  name: "LocationHealthAndSafetyAssessmentEdit",
})
export default class LocationHealthAndSafetyAssessmentEdit extends GiganautVueDialog {

public updateHealthAndSafetyAssessment = new UpdateLocationHealthAndSafetyRequest();
datePicker = false;

  @Watch("dialog")
  async onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.updateHealthAndSafetyAssessment = new UpdateLocationHealthAndSafetyRequest();
      this.updateHealthAndSafetyAssessment.healthAndSafetyAssessment = LocationDetailsModule.currentLocation.healthAndSafetyAssessment;
      this.updateHealthAndSafetyAssessment.lastHealthAndSafetyAssessmentAt = DateTimeUtils.toYYMMDD(LocationDetailsModule.currentLocation.lastHealthAndSafetyAssessmentAt);
    }
  }

  @Watch("datePicker")
  datePickerChanged(val: boolean) {
    val && setTimeout(() => ((this.$refs.picker as any).activePicker = 'YEAR'))
  }

  async saveDate(date: any) {
    (this.$refs.datePicker as any).save(date)
  }

  get loading() {
    return LocationDetailsModule.loadingDialog;
  }

  async save() {
    if (!(this.$refs.form as any).validate()) {
      return;
    }
    this.updateHealthAndSafetyAssessment.updatedAt = LocationDetailsModule.currentLocation.updatedAt;
    await LocationDetailsModule.editLocationHealthAndSafetyAssessment(this.updateHealthAndSafetyAssessment);
    this.dialog = false;
  }
}
